"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import vehicleModificationStore from "./../store/vehicleModifications";
import Toast from "vwa/components/Toast";

export default async function saveVehicle(vehicleId) {
	
	const modificationDoc = vehicleModificationStore.get(vehicleId);
	if (!modificationDoc)
		return;
	
	try {
		const response = await api.put("carriers", {
			carriers:		[modificationDoc.vehicle],
			modifications:	modificationDoc.modifications
		});
		dispatcher.dispatch("updateVehicle", response.carriers[0]);
		new Toast(lang.PROPERTIES_UPDATED, "green");
	}
	catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}


// WEBPACK FOOTER //
// ./src/api/saveVehicle.js